import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Loader } from 'ypf-pas-general-ui-components';
import { useFormikContext } from 'formik';

import { DetailRequest, DetailRequestDefaultProp } from '../../utils/globalPropTypes';
import { ApproversPermissions } from '../MonthlyServiceRequest/RequestDetailTypes';
import useToast from '../../hooks/useToast';
import { statusEnum, ubicationTypeEnum } from '../../utils/dataStatus';
import {
  formatApproversToAdd,
  formatApproversToDelete,
  formatApproversToForm,
  formatProviders,
  formatProvidersOyM
} from '../../utils/formatUtils';
import {
  getApprovers,
  getRequestTo,
  getUbicationDetail,
  updateApprovers
} from '../../services/serviceRequest';

import useAssociatedUsersForm from './useAssociatedUsersForm';
import ApproverFormSelect from './ApproverFormSelect';

const ApproverTabsForm = (props) => {
  const { values, setFieldValue } = useFormikContext();
  const { details, aprroverPermissions, approverField } = props;
  const [wells, setWells] = useState([]);
  const [contracts, setContracts] = useState([]);

  const [loadingApprovers, setLoadingApprovers] = useState(false);
  const [loadingGeneral, setLoadingGeneral] = useState(false);

  const isOyM =
    details?.tipoUbicacion?.id !== ubicationTypeEnum.pozo &&
    details?.tipoUbicacion?.id !== ubicationTypeEnum.locacion;

  const { getOptionApprover, approverOptions, filterMultipleApprovers } = useAssociatedUsersForm({
    serviceId: details.servicio?.id,
    ubicationTypeId: details?.tipoUbicacion?.id,
    ubicationTeamValue: wells?.pozos?.map((item) => item.equipo?.id),
    imptationObjectWells: wells,
    approverValue: values?.approver,
    approverField,
    contracts,
    technicalLocationId: details?.idUbicacionTecnica,
    isOyM,
    idEvento: details?.idEvento
  });

  const disabledEdit =
    details.estadoEnum === statusEnum.cancelada || details.estadoEnum === statusEnum.finalizada;

  const { setNewToast } = useToast();

  const getContracts = async () => {
    try {
      let providerContracts = [];

      if (details?.numeroContrato) {
        providerContracts = isOyM
          ? formatProvidersOyM(
              [
                {
                  numeroContrato: details.numeroContrato
                }
              ],
              details.unidadNegocio
            )
          : formatProviders(
              [
                {
                  numeroContrato: details.numeroContrato
                }
              ],
              details.unidadNegocio
            );
      }

      if (!details?.numeroContrato) {
        const dataProviders = await getRequestTo(details.id);

        providerContracts = formatProviders(dataProviders, details.unidadNegocio);
      }
      setContracts(providerContracts);
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  const getImputationObjectWells = async () => {
    try {
      const data = await getUbicationDetail(details.id);

      setWells(data);
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  const getAprroversFunction = async () => {
    setLoadingGeneral(true);

    try {
      const approversResponse = await getApprovers(details.id);

      const filteredApprovers = filterMultipleApprovers(approversResponse);

      if (approversResponse) {
        setFieldValue(`${approverField}.approvers`, formatApproversToForm(filteredApprovers));
        getContracts();
        // eslint-disable-next-line no-unused-expressions
        if (!isOyM) {
          getImputationObjectWells();
        }
      }
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }

    setLoadingGeneral(false);
  };

  useEffect(() => {
    getAprroversFunction();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (contracts.length > 0) {
      if (wells?.pozos?.length > 0 || isOyM) getOptionApprover();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contracts, wells]);

  const handleChange = async (valuesProps) => {
    setLoadingApprovers(true);
    try {
      if (values.approver?.approvers?.length > valuesProps.length)
        await updateApprovers(details.id, formatApproversToDelete(valuesProps));
      if (values.approver?.approvers?.length < valuesProps.length)
        await updateApprovers(details.id, formatApproversToAdd(valuesProps));

      const newValues = await getApprovers(details.id);

      setFieldValue(`${approverField}.approvers`, filterMultipleApprovers(newValues));
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
    setLoadingApprovers(false);
  };

  return (
    <>
      <div
        className={`approvers-container ${
          disabledEdit || !aprroverPermissions.write ? 'read-only' : ''
        }`}
      >
        <ApproverFormSelect
          isDisabled={disabledEdit || !aprroverPermissions.write}
          name="Aprobadores"
          onChange={handleChange}
          options={approverOptions}
          value={values.approver?.approvers}
        />
        <Loader show={loadingApprovers} text="Cargando" />
      </div>
      <Loader show={loadingGeneral} text="Cargando" />
    </>
  );
};

ApproverTabsForm.propTypes = {
  aprroverPermissions: ApproversPermissions,
  details: DetailRequest,
  approverField: PropTypes.string.isRequired
};

ApproverTabsForm.defaultProps = {
  aprroverPermissions: {
    visualize: false,
    write: false
  },
  details: DetailRequestDefaultProp
};

export default ApproverTabsForm;
